import { Injectable, Inject } from '@angular/core';
import { state } from '@angular/animations';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { AuthService } from '../../core/services/auth/auth.service';


export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
  profile?: number[];
  img?: string;
  main_state: string;
  icon: string;
  ind_contract: boolean;
  ind_permission: boolean;
}

export interface MainMenuItems {
  id_modulo?: number;
  state: string;
  profile?: number[];
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  img?: string;
  badge?: BadgeItem[];
  order?: number;
  view?: number;
  children?: ChildrenItems[];
  disabled?: boolean;
  ind_contract: boolean;
  ind_permission: boolean;
  lateral_icon?: string;
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const DASHBOARD = {
  label: 'INICIO',
  main: [
    {
      state: 'dashboard',
      name: 'Dashboard',
      type: 'link',
      icon: 'ti-pencil-alt',
      tab: 1,
      profile: [1, 2],
      ind_contract: true,
      ind_permission: true
    }
  ]
};

const ADMIN = {
  label: 'CONFIGURACIÒN',
  main: [
    /* {
      state: 'xml-format-setting',
      name: 'Configuración de formatos XML',
      type: 'link',
      icon: 'ti-pencil-alt',
      img: 'icon_formatosXML_512.png',
    }, */
    {
      state: 'values-list',
      name: 'Lista de valores',
      type: 'link',
      icon: 'Lista de valores.png',
      img: 'icon_listasdevalores_512.png',
    },
    /*     {
          state: 'literals',
          name: 'Literales',
          type: 'link',
          icon: 'ti-pencil-alt',
          img: 'icon_terceros_512.png',
        }, */
    /*     {
          state: 'books-parameterization',
          name: 'Parametrizar libro',
          type: 'link',
          icon: 'ti-pencil-alt',
          img: 'icon_terceros_512.png',
        }, */
    /*     {
          state: 'accounts-range',
          name: 'Rango de Cuentas',
          type: 'link',
          icon: 'ti-pencil-alt',
          img: 'icon_terceros_512.png',
        }, */
    /*     {
          state: 'segments-param',
          name: 'Segmentos',
          type: 'link',
          icon: 'ti-pencil-alt',
          img: 'icon_terceros_512.png',
        }, */
  ]
}


const USER = {
  label: 'USUARIO',
  main: [
    {
      state: 'accounting',
      name: 'Configuración Terceros',
      type: 'sub',
      icon: 'ti-pencil-alt',
      img: 'icon_terceros_512.png',
      children: [
        {
          state: 'config-third',
          name: 'Configuración Terceros',
          img: 'ti-search',
          type: 'sub',
          main_state: 'accounting',
          children: [
            {
              state: 'books-parameterization',
              name: 'Libro Contable',
              type: 'link',
              img: 'icon_terceros_512.png',
            },
            {
              state: 'legal-entity',
              name: 'Entidad Legal',
              type: 'link',
              img: 'icon_entidadlegal_512.png',
            },
            {
              state: 'load-period-table',
              name: 'Periodos Contables',
              type: 'link',
              img: 'icon_tablaperiodos_512.png',
            }
          ]
        },
        {
          state: 'load',
          name: 'Cargue Data Asientos',
          img: 'ti-search',
          type: 'sub',
          main_state: 'accounting',
          children: [
            {
              state: 'load-type-menu',
              name: 'Paso 1: Cargue asientos',
              img: 'img_12.png',
              type: 'link'
            },
            {
              state: 'validate-process',
              name: 'Paso 2: Valida asientos',
              img: 'img_12.png',
              type: 'link'
            },
            {
              state: 'balance-generation-third',
              name: 'Paso 3: Generación balance por tercero',
              img: 'img_12.png',
              type: 'link'
            }
          ]
        },
        {
          state: 'consult-third',
          name: 'Consulta de Terceros',
          img: 'ti-search',
          type: 'link',
          main_state: 'accounting'
        },
        {
          state: 'balance-third',
          name: 'Balance Por Terceros',
          img: 'ti-search',
          type: 'sub',
          main_state: 'accounting',
          children: [
            // {
            //   state: 'balance-generation-third',
            //   name: 'Generación Balance por Terceros',
            //   img: 'ti-search',
            //   type: 'link',
            //   main_state: 'balance-third'
            // },
            {
              state: 'compare-compilation-balance',
              name: 'Compara Balance vs Balance por Tercero',
              img: 'ti-search',
              type: 'link',
              main_state: 'balance-third'
            },
            {
              state: 'balance-third-acumulated',
              name: 'Informe Balance Por Tercero',
              img: 'ti-search',
              type: 'link',
              main_state: 'balance-third'
            },
            {
              state: 'auxiliary-report-by-nit',
              name: 'Informe Auxiliar por Nit',
              img: 'ti-search',
              type: 'link',
              main_state: 'balance-third'
            },
          ]
        }
      ]
    },
    {
      state: 'load-type-menu',
      name: 'Paso 1: Cargue asientos',
      img: 'icon_medios_512.png',
      icon: 'ti-pencil-alt',
      type: 'link',
    },
    {
      state: 'validate-process',
      name: 'Paso 2: Valida asientos',
      img: 'icon_medios_512.png',
      icon: 'ti-pencil-alt',
      type: 'link',
    },
    {
      state: 'balance-generation-third',
      name: 'Paso 3: Generación balance por tercero',
      img: 'icon_medios_512.png',
      icon: 'ti-pencil-alt',
      type: 'link',
    },

    {
      state: 'magnetic-media',
      name: 'Medios Magnéticos',
      img: 'icon_medios_512.png',
      icon: 'ti-pencil-alt',
      type: 'sub',
      children: [
        {
          state: 'config-third',
          name: 'Configuración Medios',
          img: 'ti-search',
          type: 'sub',
          main_state: 'magnetic-media',
          children: [
            {
              state: 'xml-format-setting',
              name: 'Formatos',
              type: 'link',
              icon: 'ti-pencil-alt',
              img: 'icon_formatosXML_512.png',
              main_state: 'config-third'
            },
            {
              state: 'literals',
              name: 'Literales',
              type: 'link',
              icon: 'ti-pencil-alt',
              img: 'icon_terceros_512.png',
              main_state: 'config-third'
            },
            {
              state: 'segments-param',
              name: 'Segmentos',
              type: 'link',
              icon: 'ti-pencil-alt',
              img: 'icon_terceros_512.png',
              main_state: 'config-third'
            },
          ]
        },
        {
          state: 'generation',
          name: 'Generación Medios Magnéticos',
          type: 'link',
          icon: 'ti-pencil-alt',
          img: 'icon_medios_512.png',
          main_state: 'magnetic-media'
        },
        {
          state: 'print-xmlformats',
          name: 'Imprimir Formatos XML',
          type: 'link',
          icon: 'ti-pencil-alt',
          img: 'icon_medios_512.png',
          main_state: 'magnetic-media'
        },
        {
          state: 'report',
          name: 'Reportes',
          img: 'ti-search',
          type: 'sub',
          main_state: 'magnetic-media',
          children: [
            {
              state: 'concepts-range',
              name: 'Conceptos y Rangos de Cuentas',
              img: 'img_12.png',
              type: 'link',
              main_state: 'report',
            },
            {
              state: 'format-concepts',
              name: 'Formatos y Conceptos',
              img: 'img_12.png',
              type: 'link',
              main_state: 'report',
            },
          ]
        },
      ]
    },


  ]

};

const SYSTEM_CONFIG = {
  label: '',
  main: [
    {
      state: 'config',
      name: 'Configuración del Sistema',
      img: 'icon_formatosXML_512.png',
      icon: 'ti-pencil-alt',
      type: 'sub',
      children: [
        {
          state: 'values-list',
          name: 'Lista de Valores',
          type: 'link',
          icon: 'Lista de valores.png',
          img: 'icon_formatosXML_512.png',
          main_state: 'config'
        },
        {
          state: 'load-interface',
          name: 'Interface de Cargues',
          type: 'link',
          icon: 'Interface de cargas.png',
          img: 'icon_formatosXML_512.png',
          main_state: 'config'
        },
        {
          state: 'schedule',
          name: 'Utilidades',
          type: 'link',
          icon: 'Utilidades.png',
          img: 'icon_formatosXML_512.png',
          main_state: 'config'
        },
        {
          state: 'massive-update',
          name: 'Actualización masiva de terceros',
          type: 'link',
          icon: 'Actualizacion_masiva_terceros.png',
          img: 'icon_formatosXML_512.png',
          main_state: 'config'
        },
        {
          state: 'load',
          name: 'Cambio de empresa',
          type: 'link',
          icon: 'Documetos Soporte.png',
          img: 'icon_formatosXML_512.png',
          main_state: 'config',
          profile: [62]
        },
        // {
        //   state: 'alert-process',
        //   name: 'alerta',
        //   type: 'link',
        //   icon: 'ti-pencil-alt',
        //   img: 'icon_formatosXML_512.png',
        //   main_state: 'config'
        // }
        {
          state: 'entity-users',
          name: 'Usuarios unidad operativa',
          type: 'link',
          icon: 'Documetos Soporte.png',
          img: 'icon_formatosXML_512.png',
          main_state: 'config'
        },
        /*{
          state: 'notify',
          name: 'Notificaciones',
          type: 'link',
          icon: 'Documetos Soporte.png',
          img: 'icon_formatosXML_512.png',
          main_state: 'config',
          profile: [62]
        },*/
        {
          state: 'update-providers',
          name: 'Actualización de Proveedores',
          type: 'link',
          icon: 'Actualizacion_masiva_proveedores.png',
          img: 'icon_formatosXML_512.png',
          main_state: 'config',
        },
      ]
    }
  ]
};
const ACCOUNTINGTHIRD = {
  label: '',
  main: [
    {
      state: 'accounting',
      name: 'Contabilidad por Terceros',
      img: 'icon_terceros_512.png',
      icon: 'ti-pencil-alt',
      type: 'sub',
      children: [
        {
          state: 'config-third',
          name: 'Configuración Terceros',
          img: 'ti-search',
          icon: 'Configuracion_terceros.png',
          type: 'sub',
          main_state: 'accounting',
          children: [
            {
              state: 'books-parameterization',
              name: 'Libro Contable',
              img: 'img_12.png',
              type: 'link',
              main_state: 'config-third',
            },
            {
              state: 'legal-entity',
              name: 'Entidad Legal',
              img: 'img_12.png',
              type: 'link',
              main_state: 'config-third',
            },
            {
              state: 'load-period-table',
              name: 'Periodos Contables',
              img: 'img_12.png',
              type: 'link',
              main_state: 'config-third',
            },
          ]
        },
        {
          state: 'load-type-menu',
          name: 'Asientos Contables',
          img: 'ti-search',
          icon: 'Asientos contables.png',
          type: 'link',
          main_state: 'accounting',
        },
        // {
        //   state: 'load-type-menu',
        //   name: 'Paso 1: Cargue Asientos',
        //   img: 'ti-search',
        //   type: 'link',
        //   main_state: 'accounting',
        // },
        // {
        //   state: 'validate-process',
        //   name: 'Paso 2: Valida Asientos',
        //   img: 'ti-search',
        //   type: 'link',
        //   main_state: 'accounting',
        // },
        // {
        //   state: 'balance-generation-third', //Valida asientos
        //   name: 'Paso 3: Generación Balance por Tercero',
        //   img: 'ti-search',
        //   type: 'link',
        //   main_state: 'accounting',
        // },
        {
          state: 'consult-third',
          name: 'Consulta de Terceros',
          img: 'ti-search',
          icon: 'Consulta De terceros.png',
          type: 'link',
          main_state: 'accounting',
        },
        {
          state: 'balance-generated',
          name: 'Estado Balances Generados',
          img: 'icon_documents_512.png',
          icon: 'Estados de balance Generados.png',
          type: 'sub',
          main_state: 'accounting',
          children: [
            {
              state: 'balance-history',
              name: 'Historial de Balance',
              img: 'img_12.png',
              type: 'link',
              main_state: 'balance-generated',
            },
          ]
        },
        {
          state: 'process',
          name: 'Procesos',
          img: 'icon_documents_512.png',
          icon: 'Procesos.png',
          type: 'sub',
          main_state: 'accounting',
          children: [
            {
              state: 'process-detail',
              name: 'Consultar Proceso',
              img: 'img_12.png',
              type: 'link',
              main_state: 'process',
            },
          ]
        },
        {
          state: 'balance-third',
          name: 'Reportes',
          img: 'ti-search',
          icon: 'Reportes.png',
          type: 'sub',
          main_state: 'accounting',
          children: [
            {
              state: 'compare-compilation-balance',
              name: 'Compare Balance vs Balance por Tercero',
              img: 'ti-search',
              type: 'link',
              main_state: 'balance-third',
              profile: [75]
            },
            {
              state: 'balance-third-acumulated',
              name: 'Informe Balance por Tercero',
              img: 'ti-search',
              type: 'link',
              main_state: 'balance-third',
            },
            {
              state: 'auxiliary-report-by-nit',
              name: 'Informe Auxiliar por Nit',
              img: 'ti-search',
              type: 'link',
              main_state: 'balance-third',
            },
            {
              state: 'report-thirdparty-info',
              name: 'Información de Terceros',
              img: 'img_12.png',
              type: 'link',
              main_state: 'report',
            },
            {
              state: 'report-balance',
              name: 'Comparacion Balance',
              img: 'ti-search',
              type: 'link',
              main_state: 'balance-third',
              profile: [73]
            },
            {
              state: 'balance-third-ica',
              name: 'Balance por Tercero ICA	',
              img: 'ti-search',
              type: 'link',
              main_state: 'balance-third',
              profile: [78]
            },
            {
              state: 'balance-third-rtica',
              name: 'Balance por Tercero ReteICA',
              img: 'ti-search',
              type: 'link',
              main_state: 'balance-third',
              profile: [78]
            },
            {
              state: 'balance-third-iva',
              name: 'Balance por Tercero IVA',
              img: 'ti-search',
              type: 'link',
              main_state: 'balance-third',
              profile: [78]
            },            
            {
              state: 'balance-third-rf',
              name: 'Balance por Tercero ReteFuente',
              img: 'ti-search',
              type: 'link',
              main_state: 'balance-third',
              profile: [78]
            },
          ]
        }
      ]
    }
  ]
};
const MAGNETIC_MEDIA = {
  label: '',
  main: [
    {
      state: 'magnetic-media',
      name: 'Medios Magnéticos Nacionales',
      img: 'icon_medios_512.png',
      icon: 'ti-pencil-alt',
      type: 'sub',
      children: [
        {
          state: 'config-third',
          name: 'Configuración Medios',
          img: 'ti-search',
          type: 'sub',
          icon: 'Configuracion_medios.png',
          main_state: 'magnetic-media',
          children: [
            {
              state: 'xml-format-setting',
              name: 'Formatos',
              type: 'link',
              icon: 'ti-pencil-alt',
              img: 'icon_formatosXML_512.png',
              main_state: 'config-third'
            },
            {
              state: 'literals',
              name: 'Conceptos y Rangos de Cuentas',
              type: 'link',
              icon: 'ti-pencil-alt',
              img: 'icon_terceros_512.png',
              main_state: 'config-third'
            },
            {
              state: 'copy-formats',
              name: 'Copiar Formatos',
              type: 'link',
              icon: 'ti-pencil-alt',
              img: 'icon_terceros_512.png',
              main_state: 'config-third'
            },
            {
              state: 'copy-concepts',
              name: 'Copiar Conceptos',
              type: 'link',
              icon: 'ti-pencil-alt',
              img: 'icon_terceros_512.png',
              main_state: 'config-third'
            },
          ]
        },
        {
          state: 'generation',
          name: 'Generación Medios Magnéticos',
          type: 'link',
          icon: 'Generacion_Medios_magneticos.png',
          img: 'icon_medios_512.png',
          main_state: 'magnetic-media'
        },
        {
          state: 'report',
          name: 'Reportes',
          img: 'ti-search',
          icon: 'Reportes_distritales.png',
          type: 'sub',
          main_state: 'magnetic-media',
          children: [
            {
              state: 'print-xmlformats',
              name: 'Generación Formatos XML',
              img: 'img_12.png',
              type: 'link',
              main_state: 'report',
            },
            {
              state: 'format-concepts',
              name: 'Formatos y Conceptos',
              img: 'img_12.png',
              type: 'link',
              main_state: 'report',
            },
            {
              state: 'concepts-range',
              name: 'Conceptos y Rangos de Cuentas',
              img: 'img_12.png',
              type: 'link',
              main_state: 'report',
            },
            {
              state: 'report-third-account-concept',
              name: 'Concepto Cuenta Tercero',
              img: 'img_12.png',
              type: 'link',
              main_state: 'report',
            },
            {
              state: 'report-thirdparty-info',
              name: 'Información de Terceros',
              img: 'img_12.png',
              type: 'link',
              main_state: 'report',
            },
            {
              state: 'report-preValidation-xml',
              name: 'Reporte Pre-Validacion XML',
              img: 'img_12.png',
              type: 'link',
              main_state: 'report',
            }
          ]
        },
      ]
    },
  ]
};
const DOCUEMTS = {
  label: '',
  main: [
    {
      state: 'documents',
      name: 'Documento Soporte',
      img: 'icon_documents_512.png',
      icon: 'ti-pencil-alt',
      type: 'sub',
      children: [
        {
          state: 'config-params',
          name: 'Configuración Parámetros',
          img: 'ti-search',
          icon: 'Configuracion_Parametros.png',
          type: 'sub',
          main_state: 'documents',
          children: [
            {
              state: 'book',
              name: 'Libro Contable',
              img: 'img_12.png',
              type: 'link',
              main_state: 'config-params',
            },
            {
              state: 'legal-entity-doc',
              name: 'Entidad Legal',
              img: 'img_12.png',
              type: 'link',
              main_state: 'config-params',
            },
            {
              state: 'resolutions-settings',
              name: 'Configuración de Resoluciones',
              img: 'img_12.png',
              type: 'link',
              main_state: 'config-params',
            },
            {
              state: 'value-list-doeq',
              name: 'Listas de Valores',
              img: 'img_12.png',
              type: 'link',
              main_state: 'config-params',
            },
            {
              state: 'load',
              name: 'Cargar Lista de Proveedores',
              img: 'img_12.png',
              type: 'link',
              main_state: 'config-params',
            },
          ]
        },
        {
          state: 'equivalent-document',
          name: 'Documento Soporte',
          img: 'ti-search',
          icon: 'Documetos Soporte.png',
          type: 'link',
          main_state: 'documents'
        },
        {
          state: 'reprint-document',
          name: 'Imprimir Documento',
          img: 'img_12.png',
          icon: 'Reimprimir Documento.png',
          type: 'link',
          main_state: 'documents'
        },
        {
          state: 'report-document',
          name: 'Reporte Documento Soporte',
          img: 'img_12.png',
          icon: 'Reporte Documento soporte.png',
          type: 'link',
          main_state: 'documents'
        },


      ]
    }
  ]
};
const PROCESS = {
  label: '',
  main: [
    {
      state: 'process',
      name: 'Detalle del proceso',
      img: 'icon_documents_512.png',
      icon: 'ti-pencil-alt',
      type: 'sub',
      children: [
        {
          state: 'process-detail',
          name: 'Consultar Proceso',
          img: 'img_12.png',
          type: 'link',
          main_state: 'process',
        },
      ]
    }
  ]
};

const BALANCE_GENERATED = {
  label: '',
  main: [
    {
      state: 'balance-generated',
      name: 'Estado Balances Generados',
      img: 'icon_documents_512.png',
      icon: 'ti-pencil-alt',
      type: 'sub',
      children: [
        {
          state: 'balance-history',
          name: 'Historial de Balance',
          img: 'img_12.png',
          type: 'link',
          main_state: 'balance-generated',
        },
      ]
    }
  ]
};

const MENUITEM = [{
  label: 'USUARIO',
  main: [
    {
      id_modulo: 44,
      state: 'config',
      name: 'Configuración Sistema',
      type: 'link',
      icon: 'ti-pencil-alt',
      img: 'icon_config.png',
      profile: [1, 62]
    },
    {
      id_modulo: 40,
      state: 'accounting',
      name: 'Contabilidad por Terceros',
      type: 'link',
      icon: 'ti-pencil-alt',
      img: 'icon_contabilidad.png',
      profile: [1, 2, 62]
    },
    {
      id_modulo: 41,
      state: 'magnetic-media',
      name: 'Medios Magnéticos Nacionales',
      img: 'icon_nacionales.png',
      icon: 'ti-pencil-alt',
      type: 'link',
      profile: [1, 2, 62]
    },
    {
      id_modulo: 42,
      state: 'documents',
      name: 'Documento Soporte',
      type: 'link',
      icon: 'ti-pencil-alt',
      img: 'icon_documentos.png',
      profile: [1, 2, 62, 65]
    },
    // {
    //   state: 'balance-generated',
    //   name: 'Estado Balances Generados',
    //   type: 'link',
    //   icon: 'ti-pencil-alt',
    //   img: 'icon_terceros_512.png',
    // },
    // {
    //   state: 'process',
    //   name: 'Procesos',
    //   type: 'link',
    //   icon: 'ti-pencil-alt',
    //   img: 'icon_terceros_512.png',
    // },
    {
      id_modulo: 43,
      state: 'magnetic-media-district',
      name: 'Medios Magnéticos Distritales',
      img: 'icon_distritales.png',
      icon: 'Configuracion_medios_distritales.png',
      type: 'link',
      profile: [1, 2, 62]
    },
    /*{
      id_modulo: 6,
      state: 'payment',
      name: 'Pagos',
      img: 'icon_pagos.png',
      icon: 'Generacion medios dist.png',
      type: 'link',
      profile: [1, 2,62]
    },*/
    {
      id_modulo: 47,
      state: 'active-resume',
      name: 'Hoja de Vida Activos',
      img: 'hv_active/hv_active_index.svg',
      icon: '',
      type: 'link',
      profile: [66, 67, 68]
    },
  ]
}];

const MAGNETIC_MEDIA_DISTRICT = {
  'label': '',
  'main': [
    {
      state: 'magnetic-media-district',
      name: 'Medios Magnéticos Distritales',
      img: 'icon_medios_512.png',
      icon: 'ti-pencil-alt',
      type: 'sub',
      children: [
        {
          state: 'config-third-district',
          name: 'Configuración Medios Distritales',
          img: 'ti-search',
          icon: 'Configuracion_medios_distritales.png',
          type: 'sub',
          main_state: 'magnetic-media-district',
          children: [
            {
              state: 'article-structure',
              name: 'Estructura Artículo',
              type: 'link',
              icon: 'ti-pencil-alt',
              img: 'icon_formatosXML_512.png',
              main_state: 'config-third-district'
            },
            {
              state: 'article-values',
              name: 'Valores Artículo',
              type: 'link',
              icon: 'ti-pencil-alt',
              img: 'icon_formatosXML_512.png',
              main_state: 'config-third-district'
            },
            {
              state: 'copy-article',
              name: 'Copia Artículos',
              type: 'link',
              icon: 'ti-pencil-alt',
              img: 'icon_formatosXML_512.png',
              main_state: 'config-third-district'
            },
          ]
        },
        {
          state: 'district-magnetic-media-generation',
          name: 'Generación de Medios Magnéticos Distritales',
          img: 'ti-search',
          icon: 'Generacion medios dist.png',
          type: 'link',
          main_state: 'magnetic-media-district',
          children: []
        },
        {
          state: 'generation-article-csv',
          name: 'Generación de Artículo CSV',
          img: 'ti-search',
          icon: 'Generacion_Articulo_CSV.png',
          type: 'link',
          main_state: 'magnetic-media-district',
          children: []
        },
        {
          state: 'reports',
          name: 'Reportes',
          img: 'ti-search',
          icon: 'Reportes_distritales.png',
          type: 'sub',
          main_state: 'magnetic-media-district',
          children: [
            {
              state: 'article-config',
              name: 'Configuración Artículos',
              img: 'ti-search',
              type: 'link',
              main_state: 'reports',
              children: []
            },
            {
              state: 'validation-account-third',
              name: 'Validación Cuenta - Tercero',
              img: 'ti-search',
              type: 'link',
              main_state: 'reports',
              children: []
            }
          ]
        }
      ]
    }
  ]
}

const PAYMENT = {
  'label': '',
  'main': [
    {
      state: 'payment',
      name: 'Pagos',
      img: 'icon_medios_512.png',
      icon: 'ti-pencil-alt',
      type: 'sub',
      children: [
        {
          state: 'dashboard',
          name: 'Dashboard',
          img: 'ti-search',
          type: 'link',
          main_state: 'payment',
          children: []
        },
      ]
    }
  ]
}

const PROFILE = {
  'label' : '',
  'main' : [
    {

      state: 'profile',
      name: 'Perfil',
      img: '',
      icon: '',
      type: 'sub',
      children: [
        {
          state: 'change-password',
          name: 'Cambiar contraseña',
          icon: 'changePassword.png',
          type: 'link',
          main_state: 'profile',
          children: []
        },
        /*{
          state: 'notification',
          name: 'Notificaciones',
          icon : 'notifications.png',
          type: 'link',
          main_state: 'profile',
          children: []
        },*/
      ]

    }
  ]

}

const ACTIVE_RESUME = {
  'label': '',
  'main': [
    {
      state: 'active-resume',
      name: 'Hoja de Vida Activos',
      type: 'sub',
      img: '',
      icon: '',
      main_state: 'active-resume',
      children: [
        {
          state: 'consulta',
          name: 'Consulta',
          icon: 'hv_active/edit_hv_active.svg',
          img: '',
          type: 'link',
          main_state: 'active-resume',
        },
        {
          state: 'bulk-load',
          name: 'Actualización masiva de ubicaciones y responsables',
          img: '',
          icon: 'hv_active/load_masive.svg',
          type: 'link',
          main_state: 'active-resume',
          profile: [66,67]
        },
        {
          state: 'bulk-load-inv',
          name: 'Actualización masiva de Inventario Fisico',
          img: '',
          icon: 'hv_active/Inventario_fisico.svg',
          type: 'link',
          main_state: 'active-resume',
          profile: [66,67]
        },
        // {
        //   state: 'reportHV',
        //   name: 'Reporte de mantenimiento',
        //   icon: 'hv_active/report_hv.svg',
        //   img: '',
        //   type: 'link',
        //   main_state: 'active-resume'
        // },
        // {
        //   state: 'report-activ',
        //   name: 'Reporte de activos fijos',
        //   icon: 'hv_active/report_hv.svg',
        //   img: '',
        //   type: 'link',
        //   main_state: 'active-resume'
        // },
        // {
        //   state: 'locations-center-cost',
        //   name: 'Maestra de centros de costo ubicaciones',
        //   icon: 'hv_active/maestra_consulta.svg',
        //   img: '',
        //   type: 'link',
        //   main_state: 'active-resume'
        // },
        {
          state: 'load-locations',
          name: 'Ubicaciones',
          icon: 'hv_active/report_hv.svg',
          img: '',
          type: 'link',
          main_state: 'active-resume',
          profile: [66]
        },
        {
          state: 'load-employees',
          name: 'Empleados',
          icon: 'hv_active/report_hv.svg',
          img: '',
          type: 'link',
          main_state: 'active-resume',
          profile: [66,67]

        },
        {
          state: 'report',
          name: 'Reportes',
          icon: 'hv_active/report_hv.svg',
          img: '',
          type: 'sub',
          main_state: 'active-resume',
          children: [
            {
              state: 'reportHV',
              name: 'Reporte de mantenimiento',
              icon: 'hv_active/report_hv.svg',
              img: '',
              type: 'link',
              main_state: 'active-resume'
            },
            {
              state: 'report-activ',
              name: 'Reporte de activos fijos',
              icon: 'hv_active/report_hv.svg',
              img: '',
              type: 'link',
              main_state: 'active-resume'
            },
            {
              state: 'locations-center-cost',
              name: 'Maestra de centros de costo ubicaciones',
              icon: 'hv_active/maestra_consulta.svg',
              img: '',
              type: 'link',
              main_state: 'active-resume'
            },
          ]
        },
        {
          state: 'tickets',
          name: 'Tickets Soporte',
          icon: 'Actualizacion_masiva_proveedores.svg',
          img: '',
          type: 'sub',
          main_state: 'active-resume',
          profile: [66,67,68],
          children: [
            {
              state: 'create',
              name: 'Crear Ticket',
              icon: 'Actualizacion_masiva_proveedores.svg',
              img: '',
              type: 'link',
              main_state: 'active-resume'
            },
            {
              state: 'filter',
              name: 'Consultar Ticket',
              icon: 'Actualizacion_masiva_proveedores.svg',
              img: '',
              type: 'link',
              main_state: 'active-resume'
            },
          ]
        },
      ]
    }
  ]
}

const NAV_MENU = {
  'config': SYSTEM_CONFIG,
  'accounting': ACCOUNTINGTHIRD,
  'magnetic-media': MAGNETIC_MEDIA,
  'documents': DOCUEMTS,
  'process': PROCESS,
  'balance-generated': BALANCE_GENERATED,
  'magnetic-media-district': MAGNETIC_MEDIA_DISTRICT,
  //'payment': PAYMENT,
  'profile' : PROFILE,
  'active-resume' : ACTIVE_RESUME
};

@Injectable()
export class MenuService {

  public user_menu = null;
  public nav_menu = {};

  constructor(
    @Inject(SESSION_STORAGE)
    private storage: StorageService,
    private _authService: AuthService
  ) { }

  getAll(profile: any[] = []): Menu[] {
    const MENUITEMS: any[] = [ACCOUNTINGTHIRD];
    return MENUITEMS;
  }

  public getNavMenu(key): Menu[] {
    if (!key) {
      return [DASHBOARD];
    }

    if (!this.user_menu){
      this.build_menu();
    }
    
    return [this.user_menu[key]];
  }

  public getMenu(user): Menu[] {
    //return MENUITEM;
    return this.getModulesUser(user);
  }

  /**
   * contruye el item de menu del usauario
   * @param item_menu item del menu a construir
   * @param item_permisson
   */
  public build_menu_item(item_menu, item_permisson, profiles){
    item_menu.ind_permission = true;
    let ind_permission       = false;
    let item                 = null;
    let items_filter;

    this.validate_profiles(item_menu, item_permisson, profiles);

    if(item_menu.children && item_menu.children.length > 0 ){

      item_menu.children.forEach(element => {

        items_filter= [];
        item        = null;
        if(item_permisson){
          items_filter = item_permisson.children.filter( child => child.state == element.state);
          item         = items_filter.length ? items_filter[0] : null;
        }

        this.build_menu_item(element, item, profiles);
        /* Si al menos unos de los hijos tiene permisos se habilita el padre */
        if(element.ind_permission) ind_permission = true;

      });

      /* Si al menos unos de los hijos tiene permisos se habilita el padre */
      item_menu.ind_permission = ind_permission;
    }

  }

  /* Construye el menu del usuario. */
  public build_menu(){

    this._authService.getSession().then( (user_data : any) => {
      if(!this.nav_menu || Object.keys(this.nav_menu).length == 0){
        this.getModulesUser(user_data); 
      }

      let permissions = user_data.menu;
      let profiles    = user_data.perfiles.map( item => { return item.id_pefil});
      this.user_menu  = {};
      // this.user_menu  = Object.assign(this.user_menu, NAV_MENU);
      this.user_menu  = Object.assign(this.user_menu, this.nav_menu);
      let keys        = Object.keys(this.user_menu);

      keys.forEach(key =>{
        this.build_menu_item(this.user_menu[key].main[0], permissions[key], profiles);
      });

      console.log(this.user_menu)
    });

    

  }


  /**
   * funcion que valida los perfiles del usario
   */
  validate_profiles(item_menu, item_permisson, user_profiles){

    let ind_super_user : boolean = user_profiles.indexOf(62) > -1;
    /* Solo se validan los permisos para usuarios estandar */
    if(item_permisson && item_permisson.ind_permission != null && !ind_super_user){
      item_menu.ind_permission = item_permisson.ind_permission;
    }

    if(item_menu.children && item_menu.children.length > 0 ){
      /* Si la opcion requiere perfil se valida el perfil del usuario*/
      item_menu.children = item_menu.children.filter( child => {
        let ind_add = true;
        if(child.profile){
          ind_add = child.profile.filter(id => { return user_profiles.indexOf(id)> -1;}).length > 0;
        }
        return ind_add;
      });

    }

  }

  /**
   * valida si el usuario tiene acceso sobre la opcion de menu.
   * @param url :  url a la que esta accediendo el usario
   * @returns  : retorna el indicador de permiso
   */
  public validate_permision(url : string){
 
    if (!this.user_menu || Object.keys(this.user_menu).length == 0){
      this.build_menu()
    }

    let url_split       = url.split('/').slice(1);
    let segment         = url_split.shift();
    let current_item    = this.user_menu[segment].main[0], aux_filter;
    let ind_permission  = current_item.ind_permission;

    url_split.forEach( state =>{
      if(current_item.children){

        aux_filter = current_item.children.filter(
          item => { return item.state == state});

        if (aux_filter.length){
        current_item    = aux_filter[0];
        ind_permission  = current_item.ind_permission;
        }

      }

    });

    return ind_permission;

  }

  /**
   * Funcion que obtienes los modulos de menu permitidos para usuario
   * @returns: Menu
   */
  public getModulesUser(user): Menu[] {
    
    let menu = [];
    if (user) {
      let data: MainMenuItems[] = user.menu.map((module) => {

        let item: MainMenuItems = {
          ...module,
          img: module.icon,
          type: 'link',
        };

        this.nav_menu[item.state] = {
          label: '',
          main: [{
            ...module,
            icon: 'ti-pencil-alt',
            img: module.icon,
            children: module.children.map((sub_menu: ChildrenItems) => {
              return {
                ...sub_menu,
                img: sub_menu.icon,
                children: sub_menu.children.map((item_menu) => {
                  return {
                    ...item_menu,
                    img: item_menu.icon
                  }
                })
              }
            }).filter(i => i.ind_permission)
          }]
        };

        return item;
      });
      menu.push({ label: 'USUARIO', main: data });
      return menu;
    }
  }

}

/**Hace la modificacion para validar los esquemas aqui . */



// WEBPACK FOOTER //
// ./src/app/shared/services/menu.service.ts